query UserTemplateCommonData {
  roles(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
}
 secureRowLevels(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
   tagGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
   accessGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
   userGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  userOccupationTitles(orderBy: USER_OCCUPATION_TITLE_ASC) {
    nodes {
      id
      userOccupationTitle
    }
  }
   userRankTypes(orderBy: USER_RANK_ASC) {
    nodes {
      id
      userRank
    }
  }
   communicationGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  dataAccessPolicies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
   departmentGroups(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
}
